import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { type BlogCategory } from "lib/sanity";
import { SidebarButton, SidebarDemo } from "components/sidebar";
import { useHeaderHeight } from "contexts/header-height";

export const defaultCategory: BlogCategory = {
  name: "All",
  slug: "all",
};

type BlogDirectoryTemplateProps = {
  categories: BlogCategory[];
  activeCategory?: BlogCategory;
  onCategoryChange: (category: BlogCategory) => void;
};

export function BlogSidebar({
  categories,
  activeCategory = defaultCategory,
  onCategoryChange,
}: BlogDirectoryTemplateProps) {
  const { headerHeight } = useHeaderHeight();

  return (
    <Flex
      as="aside"
      display={{ base: "none", lg: "flex" }}
      top={`${headerHeight + 16 * 4}px`}
      flex="0 0 260px"
      direction="column"
      pos="sticky"
      w="260px"
      px="tiniest"
      h="100%"
      // MaxHeight = headerHeight + 20px top padding + 20px bottom padding for breathing room
      maxHeight={`calc(100vh - ${headerHeight + 40}px)`}
      overflowY="auto"
    >
      <Text textStyle="overline1" fontWeight="semibold" ml="tiny">
        Categories
      </Text>

      <Flex as="ul" direction="column" mt="tinier" flex={1}>
        <Flex as="li">
          <SidebarButton
            isActive={activeCategory.slug === "all"}
            flex={1}
            onClick={() => {
              onCategoryChange(defaultCategory);
            }}
          >
            All
          </SidebarButton>
        </Flex>

        {categories.map((category) => (
          <Flex key={category.slug} as="li">
            <SidebarButton
              isActive={category.slug === activeCategory?.slug}
              flex={1}
              onClick={() => {
                onCategoryChange(category);
              }}
            >
              {category.name}
            </SidebarButton>
          </Flex>
        ))}
      </Flex>

      <SidebarDemo mt="big" />
    </Flex>
  );
}
